import { Component } from '@angular/core';
import { AppRepository, AppService } from '@timechef/core/state';
import { AccountRepository, AccountService } from '@timechef/features/account/state';

@Component({
  selector: 'app-fab-menu',
  templateUrl: './fab-menu.component.html',
  styleUrls: ['./fab-menu.component.scss'],
  standalone: false,
})
export class FabMenuComponent {
  theme$ = this.accountRepo.theme$;
  language$ = this.accountRepo.language$;

  devOverlay$ = this.appRepo.devOverlay$;
  demoProxy$ = this.appRepo.demoProxy$;
  debug$ = this.appRepo.debug$;
  prefill$ = this.appRepo.prefill$;
  newLogsCount$ = this.appRepo.newLogsCount$;

  constructor(
    private accountRepo: AccountRepository,
    private accountService: AccountService,
    private appRepo: AppRepository,
    private appService: AppService,
  ) {}

  setTheme(theme: 'dark' | 'light') {
    this.accountService.setTheme(theme);
  }

  setLanguage(language: string) {
    this.accountService.changeLanguage(language);
  }

  toggleDemoProxy() {
    this.appRepo.toggleDemoProxy();
  }

  toggleDebug() {
    this.appRepo.toggleDebug();
  }

  togglePrefill() {
    this.appRepo.togglePrefill();
  }

  openLogsModal() {
    this.appService.openLogsModal();
  }
}
